import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Formik} from 'formik'
import classNames from 'classnames'
import {TrashIcon} from '../../../icons'
import CustomSelect from '../../core/customSelect'
import {ImgButton, SimpleBlueButton} from '../../core/button'
import ButtonLoader from '../../core/button/ButtonLoader'
import {deletionReasonSchema} from '../../../utils/validation'
import {deleteAccountPermanently} from '../../../stores/customer-settings'
import CustomerService from '../../../api/customer'
import Customer from '../../../utils/customer'

const DeleteAccountSection = ({text}) => {
    const dispatch = useDispatch()
    const logoutIsProcessing = useSelector(state => state.auth.logoutIsProcessing)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const [expanded, setExpanded] = useState(false)
    const [deletionReasons, setDeletionReasons] = useState([])
    const isRootMember = Customer.isRoot()

    const initialFormValues = {
        reason: ''
    }

    const deleteAccount = async(values) => {
        await dispatch(deleteAccountPermanently({reason: values?.reason.value}))
    }

    useEffect(() => {
        const getDeletionReasonsData = async() => {
            if (!isRootMember) return
            try {
                const {data} = await CustomerService.getDeletionReasons()
                setDeletionReasons(data?.data?.reasons.map(item => ({
                    value: item?.key,
                    label: item?.description
                })))
            } catch (e) {
                return false
            }
        }

        getDeletionReasonsData()
    }, [])

    return (
        <div className='security-card security-card--danger'>
            <div className='security-card-content'>
                <div className='security-icon security-icon--danger'>
                    <TrashIcon stroke='currentColor'/>
                </div>
                <div className='security-info'>
                    <h3 className='security-card-title'>{text.delete_account_title}</h3>
                    <p className='security-card-description'>{text.delete_account_description}</p>
                </div>
                {!expanded && (
                    <ImgButton
                        type='button'
                        className={classNames('outline-red  security-delete-button', {'light-bg': !isDarkMode})}
                        onClick={() => setExpanded(true)}
                    >
                        <TrashIcon stroke='currentColor' width='16' height='16'/>
                        {text.delete_account_title}
                    </ImgButton>
                )}
            </div>
            {expanded && (
                <div className='security-card-body'>
                    {isRootMember ? (
                        <Formik
                            onSubmit={deleteAccount}
                            initialValues={initialFormValues}
                            validationSchema={deletionReasonSchema}
                            validateOnBlur={false}
                            validateOnChange={false}>
                            {({values, errors, setFieldValue, handleSubmit, isSubmitting}) => (
                                <form onSubmit={handleSubmit} className='security-delete-form'>
                                    <CustomSelect
                                        options={deletionReasons}
                                        name='reason'
                                        placeholder={text.deletion_reason}
                                        onChange={setFieldValue}
                                        infoText={text.deletion_reason_info}
                                        error={errors.reason}
                                        value={values.reason}
                                        isClearable
                                    />
                                    <div className='security-delete-actions'>
                                        <SimpleBlueButton
                                            type='button'
                                            outline
                                            onClick={() => setExpanded(false)}
                                        >
                                            {text.cancel}
                                        </SimpleBlueButton>
                                        <ImgButton
                                            type='submit'
                                            className={classNames('outline-red security-delete-button', {'light-bg': !isDarkMode})}
                                            disabled={isSubmitting || logoutIsProcessing}
                                        >
                                            {(isSubmitting || logoutIsProcessing) && <ButtonLoader/>}
                                            {text.delete}
                                        </ImgButton>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    ) : (
                        <p className='security-permission-text' dangerouslySetInnerHTML={{__html: text.permission_text}}/>
                    )}
                </div>
            )}
        </div>
    )
}

export default DeleteAccountSection
